import { useAppSelector } from "../../store/hooks";
import { useNavigate, useLocation } from "react-router-dom";

import React, { useLayoutEffect } from "react";
import { useShoppingCart } from "./context/ShoppingCartContext";
import {
  resolveNotFoundPageRedirectUrl,
  shouldNavigateToRedirectTarget,
} from "./utilities/redirectLogic";

export default function CheckNotFoundPage() {
  const isBuilder = document.getElementById("BuilderContent");

  const pageId = useAppSelector((state) => state.builder.pages.active);
  const currentPage = useAppSelector((state) => state.builder.pages.list).find(
    (x) => x.uuid === pageId
  );
  const pages = useAppSelector((state) => state.builder.pages.list);
  const navigate = useNavigate();
  const { products, productsLoaded, catalogProductsLoaded } = useShoppingCart();
  const location = useLocation();
  const website = useAppSelector((state) => state.builder.website);
  const pageLanguages = useAppSelector(
    (state) => state.builder.languageSettings.activeLanguages
  );
  const skipRedirect =
    location.pathname.includes("/webstoreApi/") ||
    location.pathname === "/webstoreApi/submitContactForm";

  const isNotFoundContext = !currentPage || currentPage.pageType === "notFound";
  const redirectUrl = resolveNotFoundPageRedirectUrl({
    skipRedirect,
    isNotFoundContext,
    isBuilder: !!isBuilder,
    productsLoaded,
    catalogProductsLoaded,
    currentPathname: location.pathname,
    currentSearch: location.search,
    pages,
    pageLanguages,
    products,
    website,
    navigatorLanguages: navigator.languages,
  });

  useLayoutEffect(() => {
    if (
      !shouldNavigateToRedirectTarget(
        redirectUrl,
        location.pathname,
        location.search
      )
    ) {
      return;
    }
    navigate(redirectUrl!, { replace: true });
  }, [redirectUrl, location.pathname, location.search, navigate]);

  return <></>;
}
